module.exports = __webpack_public_path__ + "img/random_leave.399bc4d7.jpg";